import styled from "styled-components";
import { units, visuallyHidden } from "@m/alchemy-theme";
import { NakedButton } from "../naked-button/NakedButton";
export const MultilineEllipsis = styled.div `
  padding: 0;
  white-space: normal;
  // TO DO. Needs to be fixed before deleted
  ${({ hasTextTooltip }) => hasTextTooltip && "display: inline-flex;"}; //inline-block doesn't work correctly in safari
`;
export const EllipsisContainer = styled.div `
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ lines }) => lines};
  white-space: normal;
  min-width: ${({ minWidth }) => minWidth ?? "0"};
  max-width: ${({ maxWidth }) => maxWidth ?? "none"};
  position: relative;
  word-break: ${({ disableWordBreak }) => (disableWordBreak ? "normal" : "break-word")};
`;
export const EllipsisTooltipTrigger = styled(NakedButton) `
  position: absolute;
  right: 0;
  bottom: ${units(0.5)};
  min-width: ${units(1.5)};
  min-height: ${units(1.5)};
  width: 4.5em;
  z-index: 1;

  span {
    ${visuallyHidden()}
  }
`;
